"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const RCController_1 = require("./RCController");
const index_1 = require("../index");
const DMSErrorCode_1 = require("../enums/DMSErrorCode");
class RCMasterController extends RCController_1.default {
    constructor() {
        super(...arguments);
        this.disconnect = () => {
            var _a;
            this.delegate = undefined;
            (_a = this.dmsClient) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
        this.slaves = new Array();
        this.handlePairing = (nodeId) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.slaves.indexOf(nodeId) > -1) {
                throw new Error(`already paired with: ${nodeId}`);
            }
            if (this.maxNumberOfSlaves && this.slaves.length >= this.maxNumberOfSlaves) {
                throw new Error("maxNumberOfSlaves = " + this.maxNumberOfSlaves);
            }
            try {
                this.delegate.onPairingRequest(nodeId);
                yield this.subscribeToSlaveEvents(nodeId);
                this.slaves.push(nodeId);
                this.delegate.onPairingSucceeded(nodeId);
                return this.masterId;
            }
            catch (err) {
                console.error(`pairing failed: ${JSON.stringify(err)}`);
                (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.onPairingFailed(nodeId, err);
            }
        });
        this.subscribeToSlaveEvents = (slaveId) => __awaiter(this, void 0, void 0, function* () {
            const subSlaveOfflineMsg = index_1.DMSMessageFactory.newMessage(index_1.DMSMethod.SUBSCRIBE_NODE_EVENT, {
                subscriberNodeId: this.masterId,
                subscriptionTargetNodeId: slaveId,
                event: index_1.DMSMethod.NODE_INFO_OFFLINE
            });
            const subNodeOfflineResult = yield this.dmsClient.sendMessage(subSlaveOfflineMsg, true);
            if (subNodeOfflineResult === null || subNodeOfflineResult === void 0 ? void 0 : subNodeOfflineResult.error) {
                throw subNodeOfflineResult.error;
            }
        });
        this.onSlaveOffline = (message) => {
            var _a;
            const disconnectedNode = message.payload;
            const matchingNode = this.slaves.find(uid => uid === disconnectedNode.uid);
            if (matchingNode) {
                const idx = this.slaves.indexOf(matchingNode);
                this.slaves.splice(idx, 1);
                (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.onSlaveDisconnected(matchingNode);
            }
        };
        this.start = (delegate, callables, maxNumberOfSlaves) => __awaiter(this, void 0, void 0, function* () {
            this.delegate = delegate;
            this.slaves = new Array();
            this.maxNumberOfSlaves = maxNumberOfSlaves;
            this.masterId = yield this.startImpl(delegate);
            const callableMethods = Object.keys(callables);
            callableMethods.forEach(method => {
                const callable = callables[method];
                this.dmsClient.registerCallable(method, {
                    // setup middleware, check if the sender slave is paired to master
                    implementation: (message, sender) => {
                        const idxOfSenderSlave = this.slaves.indexOf(message.sender);
                        if (idxOfSenderSlave < 0) {
                            throw new index_1.DMSError(DMSErrorCode_1.default.access_denied, "Access denied for unpaired nodes");
                        }
                        return callable.implementation(message, sender);
                    },
                    parameters: callable.parameters
                });
            });
            this.dmsClient.registerCallable(RCController_1.RCMethods.PAIR, {
                parameters: [{
                        name: "nodeId",
                        type: "string",
                    }],
                implementation: (msg) => __awaiter(this, void 0, void 0, function* () {
                    return yield this.handlePairing(msg.payload.nodeId);
                })
            });
            this.dmsClient.registerCallable(index_1.DMSMethod.NODE_INFO_OFFLINE, {
                implementation: this.onSlaveOffline,
            });
            return this.masterId;
        });
        this.getSlaves = () => {
            return this.slaves;
        };
        this.sendMessageToSlaves = (msg, awaitingResult) => __awaiter(this, void 0, void 0, function* () {
            const promisesToAwait = new Array();
            // send to slaves concurrently, then return the results when all operations have completed.
            this.slaves.forEach(slave => {
                var _a;
                msg.targetNode = slave;
                const sendPromise = (_a = this.dmsClient) === null || _a === void 0 ? void 0 : _a.sendMessage(msg, awaitingResult);
                if (sendPromise) {
                    promisesToAwait.push(sendPromise);
                }
            });
            return Promise.all(promisesToAwait);
        });
        this.sendNotificationToSlaves = (msg) => {
            this.slaves.forEach(slave => {
                var _a;
                msg.targetNode = slave;
                (_a = this.dmsClient) === null || _a === void 0 ? void 0 : _a.sendNotification(msg);
            });
        };
    }
}
exports.default = RCMasterController;
//# sourceMappingURL=RCMasterController.js.map